import svgConnect from "../../../../assets/imgs/socials/connects/youtube.svg";
import svgNaoConectado from "../../../../assets/imgs/socials/notConnects/youtube.svg";

import MyImage from "../../../myImage"

const MyIconYoutube = ({sx, connect}) =><MyImage src={connect ? svgConnect : svgNaoConectado} alt={'youtube icon'} sx={sx} />

export default MyIconYoutube;
